import { BlogPost, BlogPostFeedItem } from 'containers/blog/post/types';
import { getBlogPost as getBlogPostHelper } from 'utils/blog';
import CompoundingHabits from './compoundingHabits';
import ExplorationExploitation from './explorationExploitation';
import GoodToGreatMLLLMs from './goodToGreatML-LLMs';
import Top10Apps from './top10apps';
import TUDelftPost from './tudelft';

const blogPosts: BlogPost[] = [
  GoodToGreatMLLLMs,
  ExplorationExploitation,
  Top10Apps,
  CompoundingHabits,
  TUDelftPost,
];

export const blogPostFeedItems: BlogPostFeedItem[] = blogPosts.sort(
  (item1, item2) => -item1.date.getTime() + item2.date.getTime(),
);

export const getBlogPost = (id: string): BlogPost => getBlogPostHelper(id, blogPosts);
